/**
 * Derives the API base URL at runtime from the current browser location.
 *
 * Rules:
 *  - localhost / 127.0.0.1  → fall back to REACT_APP_API_SERVICE env var (dev only)
 *  - app.domain.com          → https://api.app.domain.com
 *  - www.app.domain.com      → https://api.app.domain.com  (www. is stripped first)
 */
export function getApiBaseUrl() {
  const { hostname, protocol } = window.location;

  // Local development fallback
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return process.env.REACT_APP_API_SERVICE || "http://localhost:5555";
  }

  // Strip leading www. if present, then prepend api.
  const baseDomain = hostname.replace(/^www\./, "");
  return `${protocol}//api.${baseDomain}`;
}
